module.exports = __webpack_public_path__ + "static/plumber-4c61ec5dac776c817315c675e3ec8c69.png";